<go-card id="form-controls">
  <ng-container go-card-header>
    <h2 class="go-heading-2 go-heading--no-wrap">Form Controls</h2>
    <go-copy cardId="form-controls" goCopyCardLink></go-copy>
  </ng-container>
  <ng-container go-card-content>
    <p class="go-body-copy">
      All of the form components in goponents are built on the
      concept of <a class="go-link" href="https://angular.io/guide/reactive-forms">Angular's reactive forms</a>
      and require a <code class="code-block--inline">FormControl</code>.
    </p>
    <h4 class="go-heading-4">As per the <a class="go-link" href="https://angular.io/guide/reactive-forms">Angular Documentation</a>:</h4>
    <p class="go-body-copy">
      The FormControl class is the basic building block when
      using reactive forms. To register a single form control,
      import the <code class="code-block--inline">FormControl</code>
      class into your component and create a new instance of
      the form control to save as a class property.
    </p>
    <h4 class="go-heading-4">Creating a basic FormControl</h4>
    <code
      [highlight]="basicFormControl"
      class="code-block--no-bottom-margin"
    ></code>
  </ng-container>
</go-card>
